import { render, staticRenderFns } from "./objectUnitSetAdd.vue?vue&type=template&id=94b54458"
import script from "./objectUnitSetAdd.vue?vue&type=script&lang=js"
export * from "./objectUnitSetAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94b54458')) {
      api.createRecord('94b54458', component.options)
    } else {
      api.reload('94b54458', component.options)
    }
    module.hot.accept("./objectUnitSetAdd.vue?vue&type=template&id=94b54458", function () {
      api.rerender('94b54458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/object/objectUnitSetAdd.vue"
export default component.exports